"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateSeedMutation = exports.useGetStartingMaterialQuery = exports.useGetSeedsQuery = exports.useGetSeedQuery = exports.seedApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
exports.seedApi = (0, react_1.createApi)({
    reducerPath: "seedApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["seed"],
    endpoints: function (builder) { return ({
        getSeed: builder.query({
            query: function (_a) {
                var id = _a.id;
                return "/v1/seeds/".concat(id);
            },
            providesTags: ["seed"],
        }),
        getSeeds: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/seeds", function (_a) {
                var status = _a.status, facilityId = _a.facilityId, inStock = _a.inStock;
                return ({
                    status: status,
                    facility_id: facilityId,
                    in_stock: inStock,
                });
            }),
            providesTags: ["seed"],
        }),
        createSeed: builder.mutation({
            query: function (_a) {
                var clientId = _a.clientId, facilityId = _a.facilityId, batchName = _a.batchName, seed = __rest(_a, ["clientId", "facilityId", "batchName"]);
                return ({
                    url: "/v1/seeds",
                    method: "POST",
                    body: __assign({ client_id: clientId, facility_id: facilityId, batch_name: batchName }, seed),
                });
            },
            invalidatesTags: ["seed"],
        }),
        getStartingMaterial: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/seeds/starting-material", function (_a) {
                var status = _a.status, facilityId = _a.facilityId;
                return ({
                    status: status,
                    facility_id: facilityId,
                });
            }),
            providesTags: ["seed"],
        }),
    }); },
});
exports.useGetSeedQuery = exports.seedApi.useGetSeedQuery, exports.useGetSeedsQuery = exports.seedApi.useGetSeedsQuery, exports.useGetStartingMaterialQuery = exports.seedApi.useGetStartingMaterialQuery, exports.useCreateSeedMutation = exports.seedApi.useCreateSeedMutation;
